module.exports = __webpack_public_path__ + "fonts/f9bdf390b18d406609b8bc51a1063702.svg";